<template>
  <div class="eduadd-wrap">
    <div class="eduadd-input">
			<!-- 学校名称 -->
			<grad-school></grad-school>
			<!-- 专业名称 -->
			<grad-major></grad-major>
			<!-- 毕业时间 -->
      <grad-time></grad-time>
    </div>
		<div class="eduadd-save">
			<span
				class="eduadd-btn eduadd-delete-btn"
				v-if="eduState === 2"
				@click="deleteEdu">
				删除
			</span>
			<span
				class="eduadd-btn eduadd-save-btn"
				:class="{'disabled': noRight}"
				@click="saveEdu">
				保存
			</span>
		</div>
		<toast v-model="errorTip" :time="time">{{errorInfo}}</toast>
  </div>
</template>

<script>
import * as types from '../../../../store/mutation-types';
import { mapGetters } from 'vuex';
import GradSchool from './gradSchool';
import GradMajor from './gradMajor';
import GradTime from './gradTime';
import eduMixin from '../../../../mixins/eduMixin';
import { Toast } from '@58fe/v5';

export default {
	data() {
		return {
			nameObj: {
				gradschool: '学校名称',
				gradmajor: '专业名称',
				gradtime: '毕业时间'
			},
			errorTip: false,
			errorInfo: '',
			showStay: false,
			showLimit: false,
			time: 1500
		};
	},
	mixins: [eduMixin],
	mounted() {
		// 添加按下态监听
		let basicList = Array.prototype.slice.call(
			document.getElementsByClassName('basic-info-detail')
		);
		basicList.forEach((item, index) => {
			item.addEventListener('touchstart', function (e) {
				this.parentNode.className += ' item-active';
			});
			item.addEventListener('touchmove', function (e) {
				this.parentNode.className = this.parentNode.className.replace(
					/item-active/g,
					''
				);
			});
			item.addEventListener('touchend', function (e) {
				this.parentNode.className = this.parentNode.className.replace(
					/item-active/g,
					''
				);
			});
		});
	},
	methods: {
		/**
		 * 保存教育经历
		 */
		saveEdu() {
			if (this.educationOk) {
				if (this.eduIndex === -1) {
					// 新增保存
					this.$store.commit(types.CHECK_BASICINFO, {
						key: 'educations',
						value: this.getAddEdu,
						state: true
					});
				} else {
					// 编辑保存
					this.$store.commit(types.CHECK_BASICINFO, {
						key: 'educations',
						value: this.getEditEdu,
						state: true
					});
				}
				// 保存教育经历埋点
				window.clickLog &&
					window.clickLog('from=xiaozhao_resumecreate1_education_complete');
				// 重置当前数据
				this.resetEdu();
			} else {
				for (let prop in this.educationCheck) {
					if (this.educationCheck.hasOwnProperty(prop) && !this.educationCheck[prop]) {
						this.errorInfo = '您的' + this.nameObj[prop] + '填写有误，请修改';
						this.errorTip = true;
						break;
					}
					if (this.educations.length === 0) {
						this.errorInfo = '您的教育经历未添加，请添加';
						this.errorTip = true;
					}
				}
			}
		},
		/**
		 * 删除教育经历
		 */
		deleteEdu() {
			this.$store.commit(types.CHECK_BASICINFO, {
				key: 'educations',
				value: this.getDeleteEdu,
				state: JSON.parse(this.getDeleteEdu).length > 0
			});
			this.resetEdu();
		}
	},
	computed: {
		...mapGetters([
			'educationCheck',
			'educations',
			'gradschool',
			'gradmajor',
			'gradtime',
			'eduState',
			'eduIndex',
			'educationOk'
		]),
		/**
		 * 新增教育经历数据
		 */
		getAddEdu() {
			let addEdu = [...this.educations];
			addEdu.push({
				id: this.educations.length,
				school: this.gradschool,
				professional: this.gradmajor,
				startDate: '',
				endDate: this.getTime
			});
			return JSON.stringify(addEdu);
		},
		/**
		 * 编辑教育经历数据
		 */
		getEditEdu() {
			let editEdu = [...this.educations];
			editEdu[this.eduIndex] = {
				id: this.eduIndex,
				school: this.gradschool,
				professional: this.gradmajor,
				startDate: '',
				endDate: this.getTime
			};
			return JSON.stringify(editEdu);
		},
		/**
		 * 删除教育经历数据
		 */
		getDeleteEdu() {
			let editEdu = [...this.educations];
			return JSON.stringify(editEdu.filter((el, n) => n !== this.eduIndex));
		},
		/**
		 * 是否可点击
		 */
		noRight() {
			return !this.gradschool || !this.gradmajor || !this.gradtime;
		},
		/**
		 * 格式化毕业时间
		 */
		getTime() {
			let timeArr = this.gradtime.split('年');
			if (timeArr.length > 1) {
				let year = timeArr[0];
				let month = timeArr[1].split('月')[0];
				return `${year}-${month}-01`;
			} else {
				return '';
			}
		}
	},
	components: {
		GradSchool,
		GradMajor,
		GradTime,
		Toast
	}
};
</script>

<style lang="scss">
@import '../../../../assets/style/public.scss';
.eduadd-wrap {
	.eduadd-save {
		text-align: center;
	}
	.eduadd-btn {
		display: inline-block;
		margin: px2rem(35px) px2rem(10px);
		padding: px2rem(6px) px2rem(60px);
		border-radius: px2rem(124px);
	}
	.eduadd-save-btn {
		border: 1px solid #ff552e;
		color: #ff552e;
		&.disabled {
			border: 1px solid #e3e3e4;
			color: #d5d5d5;
		}
	}
	.eduadd-delete-btn {
		border: 1px solid #999;
		color: #999;
	}
}
</style>



// WEBPACK FOOTER //
// index.vue?773ec4be